import { gql } from 'graphql-request';

import {
  CategoryID,
  CategoryUUID,
  CategoryNameEn,
  CategoryLocalizedName
} from '../../categories/categoriesTypes';

export interface FetchLifestyleColorsQueryResponse {
  uuid: CategoryUUID;
  id: CategoryID;
  nameEn: CategoryNameEn;
  localizedName: CategoryLocalizedName;
}

export const FETCH_LIFESTYLE_COLORS_QUERY = gql`
  query LifestyleColorsCategories(
    $filters: CategoriesFilters
    $sort: [CategoriesSortEnum!]
    $limit: Int
    $offset: Int
  ) {
    categories(filters: $filters, sort: $sort, limit: $limit, offset: $offset) {
      nodes {
        uuid
        id
        nameEn
        localizedName
      }
      sql
    }
  }
`;
